import React from 'react';

import { Button } from '../../../design-system';
import RotateCcwIcon from '../../../design-system/Icons/RotateCcwIcon';

const FormTabActionButtons = ({
    onClearForm,
    onSubmit,
    startNewProjectState,
    submitButtonState,
    hasInputs,
}) => {
    const isSuccess = startNewProjectState === 'success';

    return (
        <div
            className="fixed bottom-3 right-3 min-[1380px]:bottom-[18px] min-[1380px]:right-4 3xl:bottom-5 3xl:right-8 p-1 flex items-center gap-2.5 rounded-2"
            style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)', backdropFilter: 'blur(8px)' }}
        >
            {(hasInputs || isSuccess) && (
                <Button
                    size="sm"
                    type="link"
                    text={isSuccess ? 'New Form' : 'Clear Form'}
                    leadingIcon={RotateCcwIcon}
                    onClick={onClearForm}
                />
            )}

            {!isSuccess && (
                <Button
                    size="sm"
                    type="secondary"
                    text="Submit"
                    state={submitButtonState}
                    onClick={onSubmit}
                />
            )}
        </div>
    );
};

export default FormTabActionButtons;
